import React from "react";
import successImg from '../assets/images/Success_Icon.png'

const DepositReceiptDialog = ({ show, onClose, receipt }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
        zIndex: 9999,
      }}
    >
      {/* Card */}
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          width: "85%",
          maxWidth: "400px",
          padding: "30px 25px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
          position: "relative",
          fontFamily: "sans-serif",
        }}
      >
        {/* Close Button
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            fontSize: "18px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
          }}
        >
          ✕
        </button> */}

        {/* Success Icon */}
      <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "25px",
  }}
>
  <img
    src={successImg}
    alt="Success"
    style={{ width: "56px", height: "56px" }}
  />
</div>

        {/* Title */}
        <h2
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
            marginBottom: "25px",
          }}
        >
         {receipt.transactionTitle}
        </h2>

        <hr
  style={{
    border: "none",
    borderTop: "2px dashed transparent",
    borderImage: "repeating-linear-gradient(to right, #ddd 0, #ddd 10px, transparent 10px, transparent 20px) 1",
  }}
/>

        {/* Details */}
        <div style={{ marginTop: "25px", marginBottom: "25px" }}>
          <div style={rowStyle}>
            <span style={labelStyle}>Account Name</span>
            <span style={valueStyle}>{receipt.accountName}</span>
          </div>
          <div style={rowStyle}>
            <span style={labelStyle}>Account Number</span>
            <span style={{ ...valueStyle, fontWeight: "bold" }}>
              {receipt.accountNumber}
            </span>
          </div>
          <div style={rowStyle}>
            <span style={labelStyle}>Time</span>
            <span style={valueStyle}>{receipt.time}</span>
          </div>
          <div style={rowStyle}>
            <span style={labelStyle}>Payment Method</span>
            <span style={valueStyle}>{receipt.paymentMethod}</span>
          </div>

<hr
  style={{
    border: "none",
    borderTop: "2px dashed transparent",
    borderImage: "repeating-linear-gradient(to right, #ddd 0, #ddd 10px, transparent 10px, transparent 20px) 1",
  }}
/>

          <div style={rowStyle}>
            <span style={labelStyle}>Amount</span>
            <span style={{ ...valueStyle, fontWeight: "400" }}>
              Rs. {receipt.amounttemp}
            </span>
          </div>
        </div>

        <hr style={{ border: "none", borderTop: "1px solid #eee" }} />

        {/* Done Button */}
        <button
          onClick={onClose}
          style={{
            marginTop: "25px",
            width: "100%",
            padding: "12px",
            borderRadius: "8px",
            border: "1px solid #ddd",
            background: "#fff",
            fontWeight: "600",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
};

// Reusable styles
const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "12px",
};

const labelStyle = {
  color: "#666",
  fontSize: "14px",
   fontWeight: "400"
};

const valueStyle = {
  color: "#000",
  fontSize: "14px",
};

export default DepositReceiptDialog;
